<template>
  <div class="homeCases">
    <div id="cases" class="cases container" >
      <p class="feature-show">用户案例</p>
    </div>
    <div class="site">
      <div class="wrapper horizontal demo1">
        <ul id='container' class="container">
          <li class="cards_list" v-for="(item, index) in caseData" :key = index :id="'cardsNo' + index" :path="item.url">
              <div class="img">
                <img draggable="false" :src="item.img">
                <!-- <div class="subCtx">
                  <p class="subTile">{{item.title}}</p>
                  <p class="subDetail">{{item.detail}}</p>
                </div> -->
              </div>
          </li>
        </ul>
        <i class="btn-direct btn-left">
          <span class="shift-left"></span>
        </i>
        <i class="btn-direct btn-right">
          <span class="shift-right"></span>
        </i>
        <div class="swiperDotGroup">
          <i v-for="(item, index) in caseData" :key = index class="swiperDot fa fa-circle"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VCarousel from '../../common/js/carousel'

export default {
    name: 'homeCases',
    components: {
    },
    props: {
        caseData: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
        };
    },
    updated() {
        this.$nextTick(() => {
            this.Carousel = new Carousel($('#container'), {
                opacity: 1,
                scale: [0.9],
                offsetDistance: 90,
                transition: '400ms',
                switchBtn: $('.btn-direct'),
                swiperBtn: $('.swiperDot'),
                isClickCard: true,
                isAuto: true,
                interval: 10000000000,
            });
        });
    },
    methods: {
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  @import '~common/stylus/carousel'
  @import '~common/stylus/mixin'
.cases
    background-color:$background-white
    padding: 80px 0 50px 0
    @media (max-width: 1980px)
      .feature-show
        font-size $font-size-title
    @media (max-width: 768px)
      .feature-show
        font-size 1.44rem
    .feature-show
      padding-bottom:20px
      text-align:center
      color: $font-black
    // .caseSwiper
    //   width 100%
    //   height 357px
    //   .caseTag
    //     dom_center()
    //     width 650px
    //     height 357px
    //     position relative
    //     .subImage
    //       width 100%
    //       height 100%
    //       background-size: 100%
    //       border-radius:8px
    //       background-repeat: no-repeat
    //
    //     &:hover
    //       .subCtx
    //         height 30%
    //         visibility visible
    //         transition height 1s ease
</style>



// WEBPACK FOOTER //
// src/pages/index/home-cases.vue